module.exports = __webpack_public_path__ + "static/media/guide_mobile_03.f2fab3d7.svg";